import { useTranslation } from 'react-i18next';

import { REPORT_STATE_VARIANTS } from 'api/reports/constants';
import RowCell from 'components/Grids/DataGrid/Cells/RowCell';
import Status from 'components/Tags/Status';
import { appReactMemo } from 'hocs';

import { TReportRowCellProps } from './types';

const prefix = 'transactions.report';

const StatusCell = ({ item, ...rest }: TReportRowCellProps) => {
  const { t } = useTranslation();
  const { status } = item;
  const statusPrefix = `${prefix}.status.${status}`;

  return (
    <RowCell {...rest} item={item}>
      <Status variant={REPORT_STATE_VARIANTS[status]}>{t(statusPrefix as never)}</Status>
    </RowCell>
  );
};

export default appReactMemo(StatusCell);
